import React, { useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import { Button, Col, Form, FormCheck, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "../styles/register.css";
import { validateVendorRegistration } from "../utils/validation/vendor-validation-register";
import vendorsRegister from "../services/vendors-register";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { handleErrors } from "../utils/errorHandler";
import {
  fetchCategories,
  fetchSubCategories,
} from "../services/CategorySubCategoryService";
const VendorRegistration = () => {
  const [formData, setFormData] = useState({
    businessName: "",
    contactName: "",
    emailAddress: "",
    phoneNo: "",
    password: "",
    whatsApp: false,
  });
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [apiError, setApiError] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  // const [age, setAge] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateVendorRegistration(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      setApiError("");
      setLoading(true);
      const selectedSubCategoryIds = selectedSubCategories.map((sub) => sub.id);
      const vendorData = {
        businessName: formData.businessName,
        contactName: formData.contactName,
        emailAddress: formData.emailAddress,
        phoneNo: formData.phoneNo,
        whatsApp: formData.whatsApp ? "true" : "false",
        subCategoryId: selectedSubCategoryIds,
        pwd: formData.password,
      };

      try {
        const response = await vendorsRegister.register(vendorData);
        setLoading(false);
        setApiError("");

        const vendorGuid = response?.result?.vendor_id;
        if (vendorGuid) {
          navigate("/vendor-otp-verification", { state: { vendorGuid } });
        } else {
          setApiError("Registration successful but vendorGuid not found.");
        }
      } catch (error) {
        setLoading(false);
        setApiError(error.message || "An error occurred. Please try again.");
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleCategoryMultiChange = (event, newValue) => {
    setSelectedCategories(newValue);

    const selectedCategoryIds = newValue.map((cat) => cat.id);

    const filteredSubs = subCategories.filter((sub) =>
      selectedCategoryIds.includes(Number(sub.categoryId))
    );

    setFilteredSubCategories(filteredSubs);
    setSelectedSubCategories([]);
  };

  const handleSubCategoryMultiChange = (event, newValue) => {
    setSelectedSubCategories(newValue);
  };
  useEffect(() => {
    const fetchCategoriesData = async () => {
      try {
        const categoriesData = await fetchCategories();
        setCategories(categoriesData.result);
      } catch (error) {
        handleErrors(error);
      }
    };

    fetchCategoriesData();
  }, []);

  useEffect(() => {
    const fetchSubCategoriesData = async () => {
      try {
        const subCategoriesData = await fetchSubCategories();
        setSubCategories(subCategoriesData.result);
      } catch (error) {
        handleErrors(error);
      }
    };

    fetchSubCategoriesData();
  }, []);
  return (
    <section className="registration-section register-user">
      <div className="container">
        <div className="login-form-wrap">
          {apiError && (
            <div className="mb-2 text-sm-center">
              <div className="alert-danger rounded p-3">{apiError}</div>
            </div>
          )}
          <h2 className="form-title">Create Account</h2>
          <p> Sign up now to start your journey.</p>

          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Business Name<span className="imp-star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="businessName"
                    placeholder="Enter your Business Name"
                    value={formData.businessName}
                    onChange={handleInputChange}
                    isInvalid={!!errors.businessName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.businessName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Contact Person Name<span className="imp-star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="contactName"
                    placeholder="Enter your Contact Person Name"
                    value={formData.contactName}
                    onChange={handleInputChange}
                    isInvalid={!!errors.contactName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.contactName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="emailAddress"
                    placeholder="Enter your email address"
                    value={formData.emailAddress}
                    onChange={handleInputChange}
                    isInvalid={!!errors.emailAddress}
                  />
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Contact Number<span className="imp-star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="phoneNo"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={10}
                    placeholder="Enter your contact number"
                    value={formData.phoneNo}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits and restrict to 10 characters
                      if (/^\d{0,10}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    isInvalid={!!errors.phoneNo}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.phoneNo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Password<span className="imp-star">*</span>
                  </Form.Label>
                  <div className="password-input-container">
                    <Form.Control
                      name="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your Password"
                      value={formData.password}
                      onChange={handleInputChange}
                      isInvalid={!!errors.password}
                    />
                    <span
                      className="password-toggle-icon"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <label className="form-label">
                  Select Categories <span className="required-field">*</span>
                </label>
                <Autocomplete
                  multiple
                  id="category-checkbox-autocomplete"
                  options={categories}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.categoryName}
                  value={selectedCategories}
                  onChange={handleCategoryMultiChange}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          checked={selected}
                          style={{ marginRight: 8 }}
                        />
                        {option.categoryName}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Categories" />
                  )}
                />
              </Col>

              <Col lg={6}>
                <label className="form-label">
                  Select Sub-Categories{" "}
                  <span className="required-field">*</span>
                </label>
                <Autocomplete
                  multiple
                  id="subcategory-checkbox-autocomplete"
                  options={filteredSubCategories}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.subCategoryName}
                  value={selectedSubCategories}
                  onChange={handleSubCategoryMultiChange}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          checked={selected}
                          style={{ marginRight: 8 }}
                        />
                        {option.subCategoryName}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Sub-Categories"
                    />
                  )}
                />
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <div className="whatsapp-wrapper">
                    <Form.Check
                      type="switch"
                      id="whatsapp-toggle"
                      name="whatsApp"
                      checked={formData.whatsApp}
                      onChange={handleInputChange}
                    />
                    <span>Use WhatsApp?</span>
                  </div>
                </Form.Group>
              </Col>
              {/* <Col lg={12}>
                <div className="mt-4 forget-password">
                  <FormCheck
                    type="checkbox"
                    id="I accept the Terms & Conditions and Cancellation Policy"
                    label="I accept the Terms & Conditions and Cancellation Policy"
                    className="custom-checkbox"
                  />
                </div>
              </Col> */}
              <Col lg={12}>
                <div className="mt-4 forget-password">
                  <FormCheck
                    type="checkbox"
                    id="terms-checkbox"
                    className="custom-checkbox"
                    label={
                      <>
                        I accept the{" "}
                        <a
                          href="/terms-condition"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          Terms & Conditions and Cancellation Policy
                        </a>
                      </>
                    }
                  />
                </div>
              </Col>
            </Row>
            <Button
              type="submit"
              className="btn orange-btn mt-3"
              disabled={loading}
            >
              {loading ? "Registering..." : "Register"}
            </Button>

            <div className="dont-have-account text-start">
              <span>Already have an account?</span>
              <Link to={"/vendor-login"} className="link-page">
                Log in
              </Link>
            </div>
          </Form>
        </div>
      </div>
    </section>
  );
};

export default VendorRegistration;
